import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
  Table,
} from "react-bootstrap";
import { GoSearch } from "react-icons/go";
import WebService from "../../Services/WebService";
import Loader from "../Loader/Loader";
import NoDataFound from "../../assets/images/empty_item.svg";
import Pagination from "../Pagination/Pagination";
import {
  FileEarmarkArrowDown,
  FileEarmarkArrowUp,
} from "react-bootstrap-icons";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IoChevronBackCircleOutline } from "react-icons/io5";

const DeliveryBoyPayoutDetail = () => {
  const location = useLocation();
  const [vendorPayouts, setDeliveryBoyPayouts] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const detailPage = location.state?.page || 1;
  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState("");
  const [loader, setLoader] = useState(false);
  const [status, setStatus] = useState("");
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [currentColum, setcurrentColum] = useState("created_at");
  const [currentSort, setcurrentSort] = useState("DESC");
  const navigate = useNavigate();
  const deliveryBoyPayoutDetail = location.state?.deliveryBoyPayoutDetail;
  const menuList = useSelector((state: any) => state.profile.menus);
  const vendorAccess = menuList.find(
    (menu: any) => menu.name === "Delivery Boy Payouts"
  )?.access;

  useEffect(() => {
    fetchDeliveryBoyPayouts(page, keyword, status);
  }, [page, currentColum, currentSort, deliveryBoyPayoutDetail, keyword]);

  const fetchDeliveryBoyPayouts = (
    page: number,
    keyword?: string,
    status?: string
  ) => {
    setLoader(true);
    const offset = page - 1;
    const body = {
      offset: offset.toString(),
      keyword: keyword || "",
      status: status || "",
      sort_by: currentColum || "",
      sort_order: currentSort || "",
    };
    const queryParam = new URLSearchParams(body);
    WebService.getAPI({
      action:
        `get-delivery-boy-payout-detail/${deliveryBoyPayoutDetail.id}?` +
        queryParam,
      body: null,
      isShowError: true,
    })
      .then((res: any) => {
        setDeliveryBoyPayouts(res.list);
        setTotalCount(res.count);
        setLoader(false);
      })
      .catch((error) => {
        setLoader(false);
      });
  };

  const sorting = (sort_by: any, colum_name: any) => {
    var sortBy = sort_by;
    if (currentColum !== colum_name) {
      sortBy = "DESC";
    } else {
      if (currentSort === "DESC") {
        sortBy = "ASC";
      } else {
        sortBy = "DESC";
      }
    }
    sort_by = sortBy;
    setcurrentSort(sortBy);
    setcurrentColum(colum_name);
  };

  const dynamicSortIcons = (column: string) => {
    const isActive = currentColum === column;

    return (
      <span style={{ marginLeft: "6px", color: isActive ? "#000" : "#ccc" }}>
        {isActive ? (
          currentSort === "DESC" ? (
            <FileEarmarkArrowDown size={14} />
          ) : (
            <FileEarmarkArrowUp size={14} />
          )
        ) : (
          <span style={{ display: "inline-block", transform: "rotate(90deg)" }}>
            ↕
          </span>
        )}
      </span>
    );
  };

  const handleSearch = () => {
    setPage(1);
    setIsSearchActive(true);
    fetchDeliveryBoyPayouts(1, keyword, status);
  };

  const handleClearSearch = () => {
    setKeyword("");
    setStatus("");
    setIsSearchActive(false);
    setPage(1);
    fetchDeliveryBoyPayouts(1, "");
  };

  return (
    <>
      <Container className="page-container">
        {/* <Row className="mb-3">
          <Col>
            <div className="d-flex align-items-center">
              <Link to="/delivery-boy-payouts" state={{ detailPage }} className="text-black pe-2">
                <IoChevronBackCircleOutline size={25} />
              </Link>
              <h4 className="mb-0 text-primary">DeliveryBoy Payout List</h4>
            </div>
          </Col>
        </Row> */}
        <Row className="mb-3">
          <Col>
            <h4 className="mb-4 text-primary">DeliveryBoy Payout List</h4>
          </Col>
        </Row>
        <Card className="card-style mb-3">
          {vendorAccess && vendorAccess.can_read === "1" ? (
            <>
              <Card.Body>
                <Row>
                  <Col md={4}>
                    <InputGroup className="mb-3">
                      <InputGroup.Text id="basic-addon1">
                        <GoSearch />
                      </InputGroup.Text>
                      <Form.Control
                        placeholder="Search"
                        value={keyword}
                        onChange={(e) => setKeyword(e.target.value)}
                      />
                    </InputGroup>
                  </Col>
                  <Col md={3}>
                    {/* <Form.Select
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                      className="mb-3"
                    >
                      <option value="" disabled>
                        Select Status
                      </option>
                      <option value="ACTIVE">Active</option>
                      <option value="INACTIVE">Inactive</option>
                    </Form.Select> */}
                  </Col>
                  <Col>
                    <div className="d-flex gap-2">
                      <Button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleSearch}
                      >
                        Search
                      </Button>
                      {isSearchActive && (
                        <Button
                          type="button"
                          className="btn btn-secondary"
                          onClick={handleClearSearch}
                        >
                          Clear
                        </Button>
                      )}
                    </div>
                  </Col>
                </Row>
                {!loader ? (
                  <div className="border-radius table-responsive">
                    {vendorPayouts.length > 0 ? (
                      <Table responsive="sm">
                        <thead>
                          <tr>
                            <th
                              className="cursor-pointer"
                              onClick={() => sorting(currentSort, "order_id")}
                            >
                              Order ID {dynamicSortIcons("order_id")}
                            </th>
                            <th
                              className="cursor-pointer"
                              onClick={() => sorting(currentSort, "type")}
                            >
                              Type {dynamicSortIcons("type")}
                            </th>
                            <th
                              className="cursor-pointer"
                              onClick={() => sorting(currentSort, "amount")}
                            >
                              Amount {dynamicSortIcons("amount")}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {vendorPayouts.map((tax) => (
                            <tr key={tax.id}>
                              <td>{tax.order?.order_no}</td>
                              <td>{tax.type}</td>
                              <td>{tax.amount}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    ) : (
                      <div className="table-wrap position-relative text-center">
                        <div className="no-data-flound">
                          <div className="text-center">
                            <img
                              src={NoDataFound}
                              width={110}
                              className="mb-3"
                              alt="No Data Found"
                            />
                            <h3 className="text-secondary font-12">
                              No Record Found
                            </h3>
                          </div>
                        </div>
                      </div>
                    )}
                    {vendorPayouts.length > 0 && (
                      <Pagination
                        pagination={10}
                        totalItems={totalCount}
                        changePage={(page: number) => setPage(page)}
                        changeCurrentPage={page}
                      />
                    )}
                  </div>
                ) : (
                  <Loader show={loader} />
                )}
              </Card.Body>
            </>
          ) : (
            <>
              {" "}
              <div className="table-wrap position-relative text-center">
                <div className="no-data-flound">
                  <div className="text-center">
                    <img
                      src={NoDataFound}
                      width={110}
                      alt=""
                      className="mb-3"
                    />
                    <h3 className="text-secondary font-12">
                      Sorry, You don't have access
                    </h3>
                  </div>
                </div>
              </div>
            </>
          )}
        </Card>
      </Container>
    </>
  );
};

export default DeliveryBoyPayoutDetail;
